import { render } from "./ThemeRoot.vue?vue&type=template&id=0fe78ad8&ts=true"
import script from "./ThemeRoot.vue?vue&type=script&lang=ts"
export * from "./ThemeRoot.vue?vue&type=script&lang=ts"

import "./ThemeRoot.vue?vue&type=style&index=0&id=0fe78ad8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__